export default __webpack_public_path__ + "static/media/a038-6.7ef9fa33.svg";